const approvalStatus = [
    { label: 'In Review', value: '2' },
    { label: 'Approve', value: '3' },
    { label: 'Reject', value: '4' }
];

export default approvalStatus;
